import { Modal, Space, Descriptions, Row, Col, Statistic, Tabs, Button, Table } from 'antd';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';
import CustomerInfoEdit from 'components/customer/CustomerInfoEdit';
import CustomerLoginEdit from 'components/customer/CustomerLoginEdit';
import Debt from 'components/customer/Debt';
import _ from 'lodash';

const CustomerInfoModal = ({ viewModel, open, onClose }) => {
  const {
    customer,
    orders,
    showCustomerEdit,
    showCustomerLoginEdit,
    isAccountLoginMode,
    setShowCustomerEdit,
    setShowCustomerLoginEdit,
    onCustomerSave,
    onNavigateOrder,
  } = viewModel;

  const renderTabOrder = () => {
    const columns = [
      {
        title: 'Mã đơn hàng',
        render: (record) => (
          <Space direction='vertical'>
            <Button
              type='text'
              onClick={() => onNavigateOrder(record.id)}
            >
              {record.id}
            </Button>
            <div>{formatDate(record.create_on)}</div>
          </Space>
        ),
      },
      {
        title: 'Sản phẩm',
        render: (record) => (
          <Space direction='vertical'>
            <div>{record.total_item}</div>
            <div>{formatCurrency(record.total_amount)}</div>
          </Space>
        ),
      },
      {
        title: 'Trạng thái',
        render: (record) => (
          <Space direction='vertical'>
            {record.status === 'canceled' && <div>Đã Huỷ</div>}
            {record.status === 'finalized' && <div>Đã Hoàn tất</div>}
            {!['canceled', 'finalized'].includes(record.status) && <div>Đang xử lý</div>}
          </Space>
        ),
      },
    ];

    return <Table dataSource={orders} columns={columns} scroll={{ y: 300 }} />;
  };

  const renderTabDebt = () => {
    return <Debt customer={customer} onChange={onCustomerSave} />;
  };

  const items = [
    {
      key: 'order',
      label: 'Đơn hàng',
      children: renderTabOrder(),
    },
    {
      key: 'debt',
      label: 'Công nợ',
      children: renderTabDebt(),
    },
  ];

  return (
    <>
      <Modal
        title='Thông tin khách hàng'
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={open}
        onCancel={onClose}
        width='50%'
        footer={
          <Space>
            <Button type='link' onClick={() => setShowCustomerEdit(true)}>
              Cập nhật thông tin
            </Button>
            {isAccountLoginMode && (
              <Button type='link' onClick={() => setShowCustomerLoginEdit(true)}>
                Quản lý đăng nhập
              </Button>
            )}
            <Button onClick={onClose}>Close</Button>
          </Space>
        }
      >
        <Space style={{ width: '100%' }} direction='vertical'>
          <Descriptions column={1}>
            <Descriptions.Item label='Họ và tên'>{customer.full_name}</Descriptions.Item>
            <Descriptions.Item label='SDT'>{customer.phone}</Descriptions.Item>
            <Descriptions.Item label='Địa chỉ' span={3}>
              {customer.address}
            </Descriptions.Item>
          </Descriptions>

          <Row gutter={16}>
            <Col flex='25%'>
              <Statistic title='Đơn hàng' value={orders.length} />
            </Col>
            <Col flex='25%'>
              <Statistic
                title='Số tiền'
                value={_.sumBy(orders, (x) => x.total_amount ?? 0)}
                precision={0}
              />
            </Col>
            <Col flex='25%'>
              <Statistic
                title='Xu'
                value={customer.loyalty_point?.current ?? 0}
                precision={0}
              />
            </Col>
            {customer.debt?.current_debt !== 0 && (
              <Col flex='25%'>
                <Statistic title='Nợ' value={customer.debt?.current_debt ?? 0} precision={0} />
              </Col>
            )}
          </Row>

          <Tabs items={items} />
        </Space>
      </Modal>

      <CustomerInfoEdit
        id={customer.id}
        open={showCustomerEdit}
        onSave={onCustomerSave}
        onClose={() => setShowCustomerEdit(false)}
      />
      <CustomerLoginEdit
        id={customer.id}
        open={showCustomerLoginEdit}
        onSave={onCustomerSave}
        onClose={() => setShowCustomerLoginEdit(false)}
      />
    </>
  );
};

export default CustomerInfoModal;
